module.exports = __webpack_public_path__ + "static/img/5@2x.4969e3e1.png";